import { AxiosInstance } from "axios";
import { prefixApiUrl } from "helpers";
import { Permissions } from "models/Permissions";

export class PermissionsApi {
  constructor(private axios: AxiosInstance) {}

  async getPermissions(signal?: AbortSignal): Promise<Permissions> {
    const url = prefixApiUrl("api/permissions");
    const response = await this.axios.get<Permissions>(url, {
      signal,
      headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
    });
    return response.data;
  }
}
